module.exports = __webpack_public_path__ + "img/video_bg1.37ce761f.svg";